import { Button, Grid, TextField } from '@mui/material'
import axios from 'axios'
import moment from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { authContext } from '../../context/AuthContext'
import { useHistory } from 'react-router-dom';

import Loading from '../helper/Loading'
import PageHeader from '../helper/PageHeader'
import transactionStatusMap from '../helper/GlobalConstants'
import SortedTable from '../helper/SortedTable';

const headCells = [
    { id: 'action', centered: false, sortable: false, label: 'Action' },
   /* { id: 'id', centered: false, sortable: true, label: 'ID' },*/
    { id: 'submittedDate', centered: false, sortable: true, label: 'Date Created' },
    { id: 'submittedByUsername', centered: false, sortable: true, label: 'Submitted By' },
    { id: 'employerName', centered: false, sortable: true, label: 'Employer Name' },
    { id: 'transactionStatus', centered: false, sortable: true, label: 'Status' },
    { id: 'transactionAmount', centered: false, sortable: true, label: 'Processed Amount' },
    { id: 'confirmationNumber', centered: false, sortable: true, label: 'Confirmation Number' },
];

const bodyCells = [
  /*  { id: 'id', centered: false }, */
    { id: 'submittedDate', centered: false },
    { id: 'submittedByUsername', centered: false },
    { id: 'employerName', centered: false },
    { id: 'transactionStatus', centered: false },
    { id: 'transactionAmount', centered: false },
    { id: 'confirmationNumber', centered: false },
];

const statusMap = transactionStatusMap

const AdminViewTransactions = props => {
    const [data, setData] = useState({ data: null, loading: false })
    const mounted = useRef(true)

    const user = useContext(authContext)
    const history = useHistory()


    useEffect(() => {

        if( JSON.parse( sessionStorage.getItem('previousSearchVT') ) ){
            setData({
                data: JSON.parse(sessionStorage.getItem('previousSearchDataViewTransactions')),
                loading: false
            })
        }

        return () => mounted.current = false
    }, [])

    const handleSearch = async (search) => { 
        setData({ data: null, loading: true })
        const res = await axios.get('/api/ipay/search', {
            params: {
                fromDate: search.date
            },
            headers: {
                Authorization: user.accessToken
            }
        })

        if (mounted.current) {
            console.log(res)
            res.data.forEach(e => {
                e.submittedDate = moment(e.submittedDate).format('YYYY-MM-DD HH:mm:ss')
                e.transactionStatus = statusMap[e.transactionStatus]
            })
            setData({ data: res.data, loading: false })
            sessionStorage.setItem('previousSearchVT', true)
            sessionStorage.setItem('previousSearchDataViewTransactions', JSON.stringify(res.data) )
        }

    }

    const addBackColor = id => {
        let tempData = data.data
        for(let i =0 ; i< tempData.length;i++){
            if(tempData[i].changed===true){
                tempData[i].changed = false;
            }
            if(tempData[i].id === id){
                tempData[i].changed = true;
            }
        }
        console.log('after changed', tempData);
        sessionStorage.setItem("previousSearchDataViewTransactions", JSON.stringify(tempData));
    }

    const onView = (id) => {
        addBackColor(id);
        history.push('/administration/viewTransactions/'+id)
    }

   

    const actionButtons = [
        { icon: "view", label: "View Transaction", action: onView, delete: false },
    ];
    const editDelete = false;

    return (
        <>
            <PageHeader title="View Transaction History" />
            <SearchDate onSearch={handleSearch}  setData={setData} />
            <br />
            {data.loading === true ? <Loading /> :
                data.data === null ? <></> :
                data.data.length===0 ? <h3>No data found for this search</h3> :
                <div>
                    <h3>{data.data.length} records found for this search</h3> 
                    <SortedTable
                                data={data.data}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey="id"
                                cellKey={"id"}
                                // cellKey={"Trainee_ID"}
                                editDelete={editDelete}
                                actionButtons={actionButtons}
                                actions={true}
                                highlight="changed"
                            />
                </div>
            }

        </>

    )
}

function SearchDate(props) {
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const handleChange = event => {
        setDate(event.target.value)
    }

    const handleSearch = () => {
        sessionStorage.setItem( 'previousSearchDateVT', JSON.stringify(date) )
        props.onSearch({ date, })
    }

    const onClear = () =>{
        props.setData({ data: null, loading: false })
        setDate(moment().format('YYYY-MM-DD'))
        sessionStorage.removeItem("previousSearchVT")
        sessionStorage.removeItem("previousSearchDateVT")
        sessionStorage.removeItem("previousSearchDataViewTransactions")
    }

    useEffect(()=>{
        if( sessionStorage.getItem( 'previousSearchDateVT') ){
            setDate(JSON.parse(sessionStorage.getItem( 'previousSearchDateVT')))
        }
    }, [])

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
                <TextField
                    name='date'
                    label="From Date"
                    type="date"
                    value={date}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} md={1}>
                <Button variant="contained" color="primary" onClick={handleSearch} >Search</Button>
            </Grid>
            <Grid item xs={12} md={1}>
                <Button variant="contained" color="primary" onClick={onClear} >Clear</Button>
            </Grid>
        </Grid>
    )
}

export default AdminViewTransactions